import React, { useEffect, useState } from "react";
import Header from "../../../../Componets/Header";
import Table from "../../../../Componets/Table";
import { toast } from "react-toastify";
import tables from "../../../../Data/Tables/Settings/Roles/tables";
import headers from "../../../../Data/Tables/Settings/Roles/headers";
import roles from "../../../../Data/roles.json";
import ActionButton from "../../../../Componets/Actionbutton";
import { get_all_roles } from "../../../../Controllers/Settings/Roles";
import Loadercomponent from "../../../../Componets/Loader";
import Status from "../../../../Componets/Status";

const RolesTable = () => {
  const [loader, setLoader] = useState(false);
  const [header, setHeader] = useState(headers);
  const [body, setBody] = useState();

  const formdata = (data) => {
    fetchData(data);
  };

  const actiondata = (data) => {
    fetchData(data);
  };

  const fetchData = async (tabledata) => {
    try {
      setLoader(true);

      const params = {
        search: tabledata?.search,
        status: tabledata?.status,
      };

      const units = await get_all_roles(params);

      if (units?.status) {
        let data = [];

        units?.data?.data?.map((value, index) => {
          data?.push({
            Name: value?.name,
            Status: <Status status={value?.status} />,
            Action: (
              <ActionButton
                edit={`/app/settings/roles/edit/${value?._id}`}
                id={value?._id}
                api="delete-role"
                actiondata={actiondata}
                headers={header}
              />
            ),
          });
        });

        setBody(data);
        setLoader(false);
      } else {
        toast?.error(units?.message);
        setLoader(false);
      }
    } catch (errors) {
      toast?.error(errors?.message);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      <Loadercomponent loader={loader}>
        <Table head={tables} body={body} />
      </Loadercomponent>
    </Header>
  );
};

export default RolesTable;
